import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { formatExactDateTime, formatRelativeTime } from '@/lib/dates'

/** Relative in the row, exact on hover/focus — compact without sacrificing precision. */
export function DateTimeText({
  value,
  className,
  fallback = '—',
}: {
  value: string | null | undefined
  className?: string
  fallback?: string
}) {
  const [, tick] = useState(0)
  useEffect(() => {
    if (!value) return
    const timer = window.setInterval(() => tick((current) => current + 1), 60_000)
    return () => window.clearInterval(timer)
  }, [value])

  if (!value) return <span className={className}>{fallback}</span>
  const exact = formatExactDateTime(value)
  return (
    <time className={cn('num', className)} dateTime={value} title={exact} tabIndex={0} aria-label={exact}>
      {formatRelativeTime(value)}
    </time>
  )
}
